module.exports = __webpack_public_path__ + "static/terms_of_medical_banking_services_for_individuals_at_bank_131_archive-0859c9bc2bf193aec5b8dd57335feb49.pdf";